import { MenuConfigModel } from '@core/models/outros/menu-config.model';
import { ROUTES_APLICATION } from '@constants/routes-aplication.constants';
import { UserTypeEnum } from '@enums/user-type.enum';
import { ApplicationModules } from '@enums/application-modules.enum';

export const MENU_REGISTER: MenuConfigModel = {
  id: ApplicationModules.REGISTER,
  icon: 'list_alt',
  name: 'Cadastro',
  onlyAssociated: true,
  text: 'Aqui você pode cadastrar <strong>CFC</strong> e os <strong>instrutores</strong>, além dos <strong>candidatos</strong> e serviços oferecidos.',
  profilesToShowItems: [
    UserTypeEnum.ADMINISTRADOR,
    UserTypeEnum.OPERADOR_N1,
    UserTypeEnum.INSTRUTOR,
    UserTypeEnum.SUPERVISOR
  ],
  submenus: [
    {
      name: 'CFC',
      onlyAssociated: true,
      profilesToShowItems: [UserTypeEnum.ADMINISTRADOR],
      route: `/${ROUTES_APLICATION.register.path}/${ROUTES_APLICATION.register.cfc}`,
    },
    {
      name: 'Delegacias',
      onlyAssociated: true,
      profilesToShowItems: [UserTypeEnum.ADMINISTRADOR],
      route: `/${ROUTES_APLICATION.register.path}/${ROUTES_APLICATION.register.policeStation}`,
    },
    {
      name: 'Grupos',
      onlyAssociated: true,
      profilesToShowItems: [UserTypeEnum.ADMINISTRADOR],
      route: `/${ROUTES_APLICATION.register.path}/${ROUTES_APLICATION.register.group}`,
    },
    {
      name: 'Instrutores',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR],
      route: `/${ROUTES_APLICATION.register.path}/${ROUTES_APLICATION.register.instructor}`,
    },
    {
      name: 'Matricula',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.OPERADOR_N1,
        UserTypeEnum.INSTRUTOR,
        UserTypeEnum.SUPERVISOR
      ],
      route: `/${ROUTES_APLICATION.register.path}/${ROUTES_APLICATION.register.enrollment}`,
    },
    {
      name: 'Regiões',
      onlyAssociated: true,
      profilesToShowItems: [UserTypeEnum.ADMINISTRADOR],
      route: `/${ROUTES_APLICATION.register.path}/${ROUTES_APLICATION.register.region}`,
    },
    {
      name: 'Unidades Detran',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR
      ],
      route: `/${ROUTES_APLICATION.register.path}/${ROUTES_APLICATION.register.ciretrans}`,
    },
    {
      name: 'Usuários',
      onlyAssociated: true,
      profilesToShowItems: [UserTypeEnum.ADMINISTRADOR],
      route: `/${ROUTES_APLICATION.register.path}/${ROUTES_APLICATION.register.user}`,
    },
    {
      name: 'Veículos',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR
      ],
      route: `/${ROUTES_APLICATION.register.path}/${ROUTES_APLICATION.register.vehicle}`,
    },
    {
      name: 'Laudo',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.OPERADOR_N1,
        UserTypeEnum.SUPERVISOR
      ],
      route: `/${ROUTES_APLICATION.register.path}/${ROUTES_APLICATION.register.laudo}`,
    }
  ],
}
